import textValidator from '@/services/text/validate';
import utilities from '@/services/utilities/utilities';

export default {
  areCustomHandRankingsValid: function (customHandRankingsString) {
    customHandRankingsString = customHandRankingsString.toLowerCase();
    customHandRankingsString = customHandRankingsString.replace(/, /g, ',');

    let customHandRankingsArray = customHandRankingsString.split(',');

    if (customHandRankingsArray.length !== 169) {
      return false;
    }

    if (utilities.general.checkForDuplicates(customHandRankingsArray)) {
      return false;
    }

    for (let i = 0; i < 169; i++) {
      if (textValidator.__isHandValid(customHandRankingsArray[i]) === false) {
        return false;
      }
    }

    return true;
  },
  areTiersValid: function (tiersHandsInRangeArray) {
    for (let i = 0; i < tiersHandsInRangeArray.length; i++) {
      if (tiersHandsInRangeArray[i].length === 0) {
        return false;
      }
    }

    return true;
  },
  areSavedRangesValid: function (savedRangesArr) {
    let isValid = true;

    utilities.general.forEachNode(savedRangesArr, function (node) {
      if (!node.name) {
        isValid = false;
      }
    });

    utilities.general.forEachLeaf(savedRangesArr, function (leaf) {
      if (leaf.handsInRange.length === 0) {
        isValid = false;
      }
    });

    return isValid;
  },
};



// WEBPACK FOOTER //
// ./src/services/settings-validators.js